import AddHotelClassificationRequestModelBase from '../_generated/modelBases/add-hotel-classification-request-model-base';

export default class AddHotelClassificationRequestModel extends AddHotelClassificationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
